import { ServiceRoute } from "./../../base/service-route";
import { Observable } from "rxjs";
import { CommonHttpOption } from "./../../base/common-http-option";
import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { ICourseType } from "src/app/interfaces/course-type";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class CourseTypeService {
  constructor(private core: CoreService) { }

  list(page: number = 1, pageSize: number = 10, withCoursePattern: boolean = false, forRegister: boolean = false, forAddCourse: boolean = false): Observable<any> {
    return this.core.get(
      ServiceRoute.courseType.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
      .append("WithCoursePattern", withCoursePattern.toString())
      .append("ForAddCourse", forAddCourse.toString())
      .append("ForRegister", forRegister.toString())
    );
  }

  listWithCompany(page: number = 1, pageSize: number = 10, withCoursePattern: boolean = false, forRegister: boolean = false, forAddCourse: boolean = false, header: HttpHeaders): Observable<any> {
    return this.core.get(
      ServiceRoute.courseType.list,
      header,
      new CommonHttpOption().paginator(page, pageSize)
      .append("WithCoursePattern", withCoursePattern.toString())
      .append("ForAddCourse", forAddCourse.toString())
      .append("ForRegister", forRegister.toString())
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.courseType.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: ICourseType): Observable<any> {
    return this.core.post(
      ServiceRoute.courseType.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ICourseType): Observable<any> {
    return this.core.put(
      ServiceRoute.courseType.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  courseTypeToggleState(data: ICourseType): Observable<any> {
    return this.core.put(
      ServiceRoute.courseType.courseTypeToggleState,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.courseType.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  CourseTypeListForAddCourse(): Observable<any> {
    return this.core.get(
      ServiceRoute.courseType.CourseTypeListForAddCourse,
      new CommonHttpOption().headers
    );
  }

  courseTypeListByCurentBranch(): Observable<any> {
    return this.core.get(
      ServiceRoute.courseType.CourseTypeListByCurentBranch,
      new CommonHttpOption().headers
    );
  }

  coursesTypeByCurentBranch(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.courseTypeListByCurentBranchSTU + params.branchEncryptId,
      new CommonHttpOption().headers
    );
  }

  coursesTypeByCurentBranchAndLevel(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.courseTypeListByCurentBranchAndLevelSTU + params.branchEncryptId + '&levelInfoId=' + params.LevelInfoId,
      new CommonHttpOption().headers
    );
  }



}
